import { render } from "./eve-copy.vue?vue&type=template&id=0aa80012&scoped=true"
import script from "./eve-copy.vue?vue&type=script&lang=js"
export * from "./eve-copy.vue?vue&type=script&lang=js"

import "./eve-copy.vue?vue&type=style&index=0&id=0aa80012&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa80012"]])

export default __exports__